function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ChakraButton, IconButton as ChakraIconButton, forwardRef } from "@chakra-ui/react";
import { getTypographyStyles } from "../typography/utils";
import { iconSizeContext } from "@tempo/icons";
import { useContext } from "react";
const baseStyle = {
    outlineOffset: '0',
    outlineStyle: 'solid',
    _focusVisible: {
        boxShadow: 'none'
    }
};
const sizes = {
    medium: _object_spread_props(_object_spread({}, getTypographyStyles('body.xl.default')), {
        minH: 'size.xl',
        minW: 'size.xl',
        px: 'spacing.xl',
        py: 'spacing.m',
        borderRadius: 'm',
        gap: 'spacing.xs',
        height: 'auto'
    }),
    small: _object_spread_props(_object_spread({}, getTypographyStyles('body.m.default')), {
        minH: 'size.m',
        minW: 'size.m',
        px: 'spacing.l',
        py: 'spacing.xs',
        borderRadius: 's',
        gap: 'spacing.s',
        height: 'auto'
    })
};
const disabledContain = {
    color: 'text.accent.onDark.disabled',
    bg: 'background.accent.primary.disabled'
};
const variantContain = {
    color: 'text.accent.onDark.default',
    bg: 'background.accent.primary.default',
    outlineWidth: '2px',
    _active: {
        color: 'text.accent.onDark.pressed',
        bg: 'background.accent.primary.pressed',
        _disabled: disabledContain
    },
    _hover: {
        color: 'text.accent.onDark.hovered',
        bg: 'background.accent.primary.hovered',
        _disabled: disabledContain
    },
    _disabled: disabledContain,
    _loading: {
        color: 'text.accent.onDark.disabled',
        bg: 'background.accent.primary.disabled'
    },
    _focusVisible: {
        outlineColor: 'border.accent.primary.focused'
    }
};
const disabledOutline = {
    borderColor: 'border.neutral.primary.disabled',
    color: 'text.neutral.primary.disabled'
};
const variantOutline = {
    bg: 'transparent',
    borderColor: 'border.neutral.primary.default',
    borderStyle: 'solid',
    borderWidth: 'border.s',
    outlineWidth: '1px',
    color: 'text.neutral.primary.default',
    _active: {
        borderColor: 'border.neutral.primary.pressed',
        bg: 'background.neutral.tertiary.pressed',
        color: 'text.neutral.primary.pressed',
        _disabled: disabledOutline
    },
    _hover: {
        borderColor: 'border.neutral.primary.hovered',
        bg: 'background.neutral.tertiary.hovered',
        color: 'text.neutral.primary.hovered',
        _disabled: disabledOutline
    },
    _disabled: disabledOutline,
    _loading: {
        borderColor: 'border.neutral.primary.disabled',
        color: 'text.neutral.primary.disabled'
    },
    _focusVisible: {
        borderColor: 'border.neutral.primary.focused',
        outlineColor: 'border.neutral.primary.focused'
    }
};
const disabledGhost = {
    color: 'text.neutral.primary.disabled'
};
const variantGhost = {
    bg: 'transparent',
    color: 'text.neutral.primary.default',
    outlineWidth: '2px',
    _active: {
        color: 'text.neutral.primary.pressed',
        bg: 'background.neutral.tertiary.pressed',
        _disabled: disabledGhost
    },
    _hover: {
        color: 'text.neutral.primary.hovered',
        bg: 'background.neutral.tertiary.hovered',
        _disabled: disabledGhost
    },
    _disabled: disabledGhost,
    _loading: {
        color: 'text.neutral.primary.disabled'
    },
    _focusVisible: {
        outlineColor: 'border.neutral.primary.focused'
    }
};
const variantOnContent = {
    bg: 'background.accent.onContent.default',
    borderColor: 'border.accent.onContent.default',
    borderStyle: 'solid',
    borderWidth: 'border.s',
    outlineWidth: '1px',
    color: 'text.neutral.primary.default',
    _active: {
        borderColor: 'border.accent.onContent.pressed',
        bg: 'background.accent.onContent.pressed',
        color: 'text.neutral.primary.pressed'
    },
    _hover: {
        borderColor: 'border.accent.onContent.hovered',
        bg: 'background.accent.onContent.hovered',
        color: 'text.neutral.primary.hovered'
    },
    _disabled: {
        borderColor: 'border.accent.onContent.disabled',
        bg: 'background.accent.onContent.disabled',
        color: 'text.neutral.primary.disabled'
    },
    _loading: {
        borderColor: 'border.accent.onContent.disabled',
        bg: 'background.accent.onContent.disabled',
        color: 'text.neutral.primary.disabled'
    },
    _focusVisible: {
        borderColor: 'border.neutral.primary.focused',
        outlineColor: 'border.neutral.primary.focused'
    }
};
const variantOnLight = {
    bg: 'background.accent.onLight.default',
    color: 'text.accent.onDark.default',
    outlineColor: 'transparent',
    outlineWidth: '2px',
    _active: {
        bg: 'background.accent.onLight.pressed',
        color: 'text.accent.onDark.pressed'
    },
    _hover: {
        bg: 'background.accent.onLight.hovered',
        color: 'text.accent.onDark.hovered'
    },
    _disabled: {
        bg: 'background.accent.onLight.disabled',
        color: 'text.accent.onDark.disabled'
    },
    _loading: {
        bg: 'background.accent.onLight.disabled',
        color: 'text.accent.onDark.disabled'
    },
    _focusVisible: {
        outlineColor: 'border.neutral.primary.focused'
    }
};
const variantOnDark = {
    bg: 'background.accent.onDark.default',
    color: 'text.accent.onLight.default',
    outlineColor: 'transparent',
    outlineWidth: '2px',
    _active: {
        bg: 'background.accent.onDark.pressed',
        color: 'text.accent.onLight.pressed'
    },
    _hover: {
        bg: 'background.accent.onDark.hovered',
        color: 'text.accent.onLight.hovered'
    },
    _disabled: {
        bg: 'background.accent.onDark.disabled',
        color: 'text.accent.onLight.disabled'
    },
    _loading: {
        bg: 'background.accent.onDark.disabled',
        color: 'text.accent.onLight.disabled'
    },
    _focusVisible: {
        outlineColor: 'border.neutral.primary.focused'
    }
};
const defaultProps = {
    variant: 'contain',
    size: 'medium'
};
export const ThemedButton = {
    baseStyle,
    variants: {
        contain: variantContain,
        outline: variantOutline,
        ghost: variantGhost,
        onContent: variantOnContent,
        onLight: variantOnLight,
        onDark: variantOnDark
    },
    sizes: sizes,
    defaultProps: defaultProps
};
const Button = forwardRef((_param, ref)=>{
    var { iconSpacing } = _param, props = _object_without_properties(_param, [
        "iconSpacing"
    ]);
    const paddingStart = props.leftIcon ? props.size === 'small' ? 'spacing.s' : 'spacing.l' : undefined;
    const paddingEnd = props.rightIcon ? props.size === 'small' ? 'spacing.s' : 'spacing.l' : undefined;
    // Keep parent context if any (eg ButtonGroup)
    const size = useContext(iconSizeContext);
    return /*#__PURE__*/ _jsx(iconSizeContext.Provider, {
        value: size || props.size,
        children: /*#__PURE__*/ _jsx(ChakraButton, _object_spread({
            ref: ref,
            paddingStart: paddingStart,
            paddingEnd: paddingEnd,
            iconSpacing: "0px"
        }, props))
    });
});
Button.displayName = 'Button';
const IconButton = forwardRef((_param, ref)=>{
    var { isRound } = _param, props = _object_without_properties(_param, [
        "isRound"
    ]);
    // Keep parent context if any (eg ButtonGroup)
    const size = useContext(iconSizeContext);
    return /*#__PURE__*/ _jsx(iconSizeContext.Provider, {
        value: size || props.size,
        children: /*#__PURE__*/ _jsx(ChakraIconButton, _object_spread_props(_object_spread({
            ref: ref
        }, props), {
            isRound: true
        }))
    });
});
IconButton.displayName = 'IconButton';
export { Button, IconButton };

//# sourceMappingURL=Button.js.map